import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create("SchedulingChannel", {
      connected: this._connected.bind(this),
      disconnected: this._disconnected.bind(this),
      received: this._received.bind(this)
    })
  }

  disconnect() {
    this.consumer.subscriptions.remove(this.subscription)
  }

  _connected() {
    console.log("SchedulerReloader: Conectado a SchedulingChannel.")
  }

  _disconnected() {
    console.log("SchedulerReloader: Desconectado de SchedulingChannel.")
  }

  _received(data) {
    console.log("SchedulerReloader: Datos recibidos:", data)
    if (data.status === 'completed') {
      console.log("SchedulerReloader: Recibido estado 'completed'. Recargando página...")
      // Usamos Turbo.visit para una recarga más suave si Turbo está disponible,
      // de lo contrario, un fallback a la recarga completa.
      if (window.Turbo) {
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        window.location.reload()
      }
    }
  }
}
